import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, shallowRef } from "vue";
import Ajax from "@/utils/DuduAjax";
import { API_BIS_PATENT_TREE, API_BIS_PATENT_TREE_CHILDREN } from "@/configs/Apis";
import Ipc from "@/views/components/IpcTag.vue";
import { useStore } from "@/stores";


export default /*#__PURE__*/_defineComponent({
  __name: 'NavTreePanel',
  emits: ["node-click"],
  setup(__props, { expose, emit }) {

const store = useStore();

const PAGE_SIZE = 10;

const projectId = computed(() => {
  const pInfo: any = (store.state as any).project.info || {};
  return pInfo.id || 0;
});



const defaultProps = ref({
  children: "children",
  label: "title",
});

const treeData = ref<Array<any>>([]);

const treeRef = shallowRef();
// 记录每个分类已加载到的页码: { [parentId]: page }
const loadedPages = ref<Record<string, number>>({});

const createLoadMoreNode = (parentId: string) => ({
  // 占位节点也要有唯一 nodeId, 否则与 el-tree 的 node-key 冲突
  nodeId: `loadmore-${parentId}`,
  title: "加载更多",
  loadMore: true,
  loading: false,
  parentId,
});

const loadNavTree = () => {
  Ajax.get<Array<any>>(
    {
      url: API_BIS_PATENT_TREE,
      path: { projectId: projectId.value },
    },
    {},
    false
  ).then((data) => {
    treeData.value = [{ nodeId: 0, title: "全部", patentFilter: { filterCondition: "" } }].concat(data);
    data.forEach((node: any) => {
      // 分类子节点达到一页数量时, 在其末尾追加"加载更多"节点
      if (node.nodeId && node.children && node.children.length >= PAGE_SIZE) {
        node.children.push(createLoadMoreNode(node.nodeId));
        loadedPages.value[node.nodeId] = 1;
      }
    });
  });
};

const loadMore = (marker: any) => {
  if (marker.loading) {
    return;
  }
  marker.loading = true;
  const nextPage = (loadedPages.value[marker.parentId] || 1) + 1;
  Ajax.get<Array<any>>(
    {
      url: API_BIS_PATENT_TREE_CHILDREN,
      path: { projectId: projectId.value },
    },
    { parentId: marker.parentId, page: nextPage, pageSize: PAGE_SIZE },
    false
  )
    .then((items: any) => {
      loadedPages.value[marker.parentId] = nextPage;
      const parent = treeData.value.find((n: any) => n.nodeId === marker.parentId);
      if (parent && parent.children) {
        // 移除"加载更多"占位节点, 再追加下一页数据
        const index = parent.children.indexOf(marker);
        if (index > -1) {
          parent.children.splice(index, 1);
        }
        parent.children.push(...(items || []));
        // 仍有更多时继续保留"加载更多"
        if (items && items.length >= PAGE_SIZE) {
          parent.children.push(createLoadMoreNode(marker.parentId));
        }
      }
      marker.loading = false;
    })
    .catch(() => {
      marker.loading = false;
    });
};

const onNodeClick = (node: any) => {
  if (node.loadMore) {
    loadMore(node);
    return;
  }
  emit("node-click", node);
};

/** 供父组件在切到自定义分类/筛选时清除导航分类的选中高亮 */
const clearSelectedItems = () => {
  treeRef.value?.setCurrentKey(null);
};

expose({ clearSelectedItems });

loadNavTree();

return { __sfc: true,store, PAGE_SIZE, projectId, emit, defaultProps, treeData, treeRef, loadedPages, createLoadMoreNode, loadNavTree, loadMore, onNodeClick, clearSelectedItems, Ipc }
}

})